export enum AuthStatus{
   Authenticated, // User successfully 
   Failed, //Attempt to authenticated failed
   LoggedOut, // User manually logged out
   TimedOut, // Session has timed out
   Unauthenticated, // User has yet to be authenticated
   Waiting, // Status of the user is unknown
}